
import React from 'react'
import {
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
} from '@mui/material'
import { NumericFormat } from 'react-number-format'
import BlockUi from 'react-block-ui'
import { PacmanLoader } from 'react-spinners'
import { map } from '@/utils/lodash'
import Add from '@mui/icons-material/Add'

const AddLotDialog = ({
  open,
  onClose,
  onSubmit,
  portfolios,
  lotPortfolios,
  loading,
  userListPrice,
  setUserListPrice,
  selectedPortfolio,
  setSelectedPortfolio,
  ownedLot,
  setOwnedLot,
  query,
  setQuery,
  openPortfolio,
  handleOpenPortfolio,
  handleClosePortfolio,
  loader,
  minutes,
  seconds,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      onKeyDown={(e) => {
        if (e.key === 'Tab') e.stopPropagation()
      }}
    >
      <DialogTitle>Add Single Lot</DialogTitle>
      <form
        style={{
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
        onSubmit={onSubmit}
      >
        <DialogContent sx={{ overflow: 'visible' }} data-hf="places-dialog-content">
          <BlockUi
            blocking={loader}
            loader={
              <PacmanLoader color={'var(--primary)'} loading={true} />
            }
            message={
              <Box sx={{ color: '#368cff' }}>
                <p>Connecting</p>
                <p>
                  {(((minutes * 60 + seconds) / 120) * 100).toFixed(
                    1,
                  )}
                  % Complete
                </p>
              </Box>
            }
          >
            <DialogContentText>
              Type an address below and we will automatically gather
              data and analyze it for you even if it's not on the MLS!
            </DialogContentText>
            <Grid container direction="row" spacing={1}>
              <Grid size={{ xs: 12, sm: 12 }}>
                <Typography
                  component="label"
                  htmlFor="autocomplete"
                  variant="body2"
                  sx={{
                    display: 'block',
                    mb: 0.5,
                    color: 'text.secondary',
                  }}
                >
                  Address
                </Typography>
                <Box data-hf-place-field="" sx={{
                  width: "100%",
                  position: "relative",
                  minHeight: 40,
                  marginTop: 0,
                  "& > input": { display: "none" },
                }}>
                  <input
                    id="autocomplete"
                    type="text"
                    placeholder="Search Property"
                    name="query"
                    onChange={(event) => setQuery(event.target.value)}
                    autoFocus
                    aria-label="Address"
                  />
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <NumericFormat
                  customInput={TextField}
                  placeholder="Asking Price"
                  label="Asking Price"
                  thousandSeparator={true}
                  prefix={'$'}
                  fullWidth={true}
                  margin="dense"
                  variant="outlined"
                  size="small"
                  onFocus={(event) => {
                    event.target.select()
                  }}
                  allowNegative={false}
                  decimalScale={0}
                  value={userListPrice}
                  onValueChange={(values) => {
                    const { value } = values
                    setUserListPrice(value)
                  }}
                  helperText="Not sure? Give us a ballpark estimate"
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <FormControl
                  variant="outlined"
                  margin="dense"
                  style={{ width: '100%' }}
                >
                  <InputLabel id="demo-simple-select-label">
                    Portfolio
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="selectedPortfolio"
                    value={selectedPortfolio}
                    onChange={(event) =>
                      setSelectedPortfolio(event.target.value)
                    }
                    open={openPortfolio}
                    onOpen={handleOpenPortfolio}
                    onClose={handleClosePortfolio}
                    MenuProps={{ keepMounted: true }}
                    fullWidth={true}
                    label="Portfolio"
                  >
                    {map(lotPortfolios, (option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={12}>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    value={ownedLot}
                    onChange={(event) =>
                      setOwnedLot(event.target.value)
                    }
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value="edit"
                      label={<Typography>Analyze Lot</Typography>}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="approved"
                      label={<Typography>View Lot</Typography>}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="owned"
                      label={<Typography>I Own This Lot</Typography>}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </BlockUi>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="text">
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={!selectedPortfolio || loading}
          >
            Search
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default AddLotDialog
